import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

interface City {
    name: string;
    api: string;
}

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.less'],
    imports: [CommonModule, RouterLink, FormsModule]
})
export class MenuComponent implements OnInit {
    cities: City[] = [];
    currentCity: string = 'all';
    currentUrl: string = '';
    isCollapsed: boolean = true;

    constructor(
        private apiService: ApiService,
        private router: Router
    ) {}

    ngOnInit(): void {
        console.log('Menu component initialized');
        
        // Get cities list
        this.apiService.get<City[]>('content', 'getCities').subscribe({
            next: (response: any) => {
                console.log('Cities response:', response);
                if (response.obj && Array.isArray(response.obj)) {
                    this.cities = response.obj;
                    console.log('Cities loaded:', this.cities);
                }
            },
            error: (error: any) => {
                console.error('Error fetching cities:', error);
            }
        });

        // Track current route
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: any) => {
            this.currentUrl = event.url;
            console.log('Route changed to:', this.currentUrl);
        });
    }

    switchCity(): void {
        if (this.currentCity === 'all') {
            this.router.navigate(['/feed']);
        } else {
            this.router.navigate(['/feed', this.currentCity]);
        }
    }

    isActive(link: string): boolean {
        return this.currentUrl.includes(link);
    }

    toggleMenu(): void {
        this.isCollapsed = !this.isCollapsed;
    }

    closeMenu(): void {
        this.isCollapsed = true;
    }
}
